import axios from 'axios';
import {axiosConfig as config} from 'config/axiosConfig';

const {REACT_APP_API} = process.env;
const baseUrl = `${REACT_APP_API}/niveles-structure`;

export const getAll = async ({page = '', limit = '', nivel = '', flujo = ""}) => {
 const {data} = await axios.get(`${baseUrl}/?page=${page}&limit=${limit}&nivel=${nivel}&flujo=${flujo}`, config)
 return data
}

export const create = async ({nivel = {}}) => {
 const {data} = await axios.post(baseUrl, nivel, config)
 return data
}

export const update = async ({nivel = {}, id}) => {
 const {data} = await axios.put(`${baseUrl}/${id}`, nivel, config)
 return data
}

export const del = async ({id}) => {
 const {data} = await axios.delete(`${baseUrl}/${id}`, config)
 return data
}